import * as MESSAGES from './messages';

enum LocaleCode {
  RU = 'ru',
  EN = 'en',
  DE = 'de',
  ES = 'es',
  FR = 'fr',
  IT = 'it',
  PT = 'pt',
  JA = 'ja',
  KO = 'ko',
  ZH = 'zh',
  ZHT = 'zht',
}

const LOCALES: Array<string> = [
  LocaleCode.RU,
  LocaleCode.EN,
  LocaleCode.DE,
  LocaleCode.ES,
  LocaleCode.FR,
  LocaleCode.IT,
  LocaleCode.PT,
  LocaleCode.JA,
  LocaleCode.KO,
  LocaleCode.ZH,
  LocaleCode.ZHT,
];

const FALLBACK_LOCALE: string = LocaleCode.EN;

const LANGUAGES: Record<string, string> = {
  [LocaleCode.RU]: 'Русский',
  [LocaleCode.EN]: 'English',
  [LocaleCode.DE]: 'Deutsch',
  [LocaleCode.ES]: 'Español',
  [LocaleCode.FR]: 'Français',
  [LocaleCode.IT]: 'Italiano',
  [LocaleCode.PT]: 'Português',
  [LocaleCode.JA]: '日本語',
  [LocaleCode.KO]: '한국어/韓國語',
  [LocaleCode.ZH]: '汉语',
  [LocaleCode.ZHT]: '漢語',
};

const ISO_LOCALES: Record<string, string> = {
  [LocaleCode.RU]: 'ru_RU',
  [LocaleCode.EN]: 'en_US',
  [LocaleCode.DE]: 'de_DE',
  [LocaleCode.ES]: 'es_ES',
  [LocaleCode.FR]: 'fr_FR',
  [LocaleCode.IT]: 'it_IT',
  [LocaleCode.PT]: 'pt_BR',
  [LocaleCode.JA]: 'ja_JP',
  [LocaleCode.KO]: 'ko_KR',
  [LocaleCode.ZH]: 'zh_CN',
  [LocaleCode.ZHT]: 'zh_TW',
};

export { LocaleCode, LOCALES, LANGUAGES, FALLBACK_LOCALE, ISO_LOCALES, MESSAGES };
